import React from 'react';
import { Helmet } from "react-helmet";
import { FaVideo, FaCut, FaMagic, FaYoutube, FaInstagram, FaChartBar } from 'react-icons/fa';
import "./VideoEditing.css";

const VideoEditing = () => {
  return (
    <main className="service-page">
      <Helmet>
        <title>Professional Video Editing & Production | Skyline Bussiness Solutions</title>

        <meta 
          name="description" 
          content="High-retention video editing by Skyline Bussiness Solutions. Visit skylinebussinesssolutions.com for YouTube videos, Reels, and professional editing services." 
        />

        {/* ✅ CANONICAL */}
        <link rel="canonical" href="https://skylinebussinesssolutions.com/video-editing" />
      </Helmet>

      {/* HERO SECTION */}
      <header className="service-hero">
        <div className="service-hero-content">
          <span className="service-badge">MOTION ARCHITECTURE</span>
          <h1 className="service-display">
            Visual <br />
            <span className="accent-text">Retention Engineering</span>
          </h1>

          <p className="service-intro">
            At <strong>Skyline Bussiness Solutions</strong>, we don't just cut clips; we 
            <strong> engineer attention</strong>. Our post-production specializes 
            in high-performance editing that maximizes viewer retention and brand authority. 
            Visit <strong>skylinebussinesssolutions.com</strong> to grow your content.
          </p>
        </div>
      </header>

      <div className="service-container">
        
        {/* STRATEGY */}
        <section className="strategy-section">
          <div className="strategy-card">
            <div className="strat-icon"><FaMagic /></div>
            <h3>Dynamic Pacing</h3>
            <p>Editing patterns designed to maintain engagement and reduce drop-off.</p>
          </div>

          <div className="strategy-card">
            <div className="strat-icon"><FaCut /></div>
            <h3>Storytelling</h3>
            <p>Transforming raw footage into powerful narratives aligned with your brand.</p>
          </div>

          <div className="strategy-card">
            <div className="strat-icon"><FaChartBar /></div>
            <h3>Conversion Focus</h3>
            <p>Strategic CTAs and motion graphics to drive engagement and ROI.</p>
          </div>
        </section>

        {/* CAPABILITIES */}
        <section className="capabilities-grid">
          <div className="glass-card">
            <FaYoutube className="card-icon" />
            <h3>YouTube Editing</h3>
            <p>Professional long-form videos with smooth transitions and color grading.</p>
          </div>

          <div className="glass-card">
            <FaInstagram className="card-icon" />
            <h3>Reels & Shorts</h3>
            <p>High-energy short videos optimized for mobile and viral growth.</p>
          </div>

          <div className="glass-card">
            <FaVideo className="card-icon" />
            <h3>Corporate Videos</h3>
            <p>Premium editing for ads, presentations, and business branding.</p>
          </div>
        </section>

        {/* WORKFLOW */}
        <section className="workflow-section">
          <div className="section-header">
            <h2>The Production Lifecycle</h2>
            <div className="line"></div>
          </div>

          <div className="workflow-steps">
            <div className="step">
              <span>01</span>
              <h4>Review</h4>
              <p>Analyzing raw footage for best content and hooks.</p>
            </div>

            <div className="step">
              <span>02</span>
              <h4>Edit</h4>
              <p>Creating structured videos with effects and storytelling.</p>
            </div>

            <div className="step">
              <span>03</span>
              <h4>Finalize</h4>
              <p>Color grading, sound design, and export optimization.</p>
            </div>
          </div>
        </section>
      </div>

      {/* ✅ SCHEMA */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Professional Video Editing Services",
          "provider": {
            "@type": "Organization",
            "name": "Skyline Bussiness Solutions",
            "url": "https://skylinebussinesssolutions.com"
          },
          "url": "https://skylinebussinesssolutions.com/video-editing",
          "description": "Video editing services for YouTube, Reels, and corporate marketing."
        })}
      </script>
    </main>
  );
};

export default VideoEditing;